import { render, staticRenderFns } from "./attachmentOfStatement.vue?vue&type=template&id=35070835"
import script from "./attachmentOfStatement.vue?vue&type=script&lang=js"
export * from "./attachmentOfStatement.vue?vue&type=script&lang=js"
import style0 from "./attachmentOfStatement.vue?vue&type=style&index=0&id=35070835&prod&lang=less&scope=true"
import style1 from "./attachmentOfStatement.vue?vue&type=style&index=1&id=35070835&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports